import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";
import {mediaQueries} from "@khan/shared-styles";
import {cssUrl} from "@khan/urls";

import * as urls from "../../lib/urls.ts";

export default function InsideScoopModule(): React.ReactElement {
    return (
        <View style={styles.content}>
            <h1 className={css(styles.title)}>
                {t`The inside scoop on the new digital SAT`}
            </h1>
            <Body style={styles.bodyText}>
                {t`Get a sneak peek into the new digital SAT. Learn more about the test format and the best way to prepare.`}
            </Body>
            <Button
                size="large"
                style={styles.learnMore}
                href={urls.digitalSatInsideScoopUrl}
            >
                {t`Learn more`}
            </Button>
        </View>
    );
}

const styles = StyleSheet.create({
    content: {
        backgroundImage: cssUrl(
            "/images/dsat-landing/inside-scoop-background.png",
        ),
        backgroundRepeat: "no-repeat",
        backgroundSize: "848px auto",
        backgroundPosition: "50% 80%",
        alignItems: "center",
        paddingTop: 112,
        paddingBottom: 240,
        paddingLeft: spacing.xLarge_32,
        paddingRight: spacing.xLarge_32,
        [mediaQueries.smOrSmaller]: {
            paddingTop: spacing.xxxLarge_64,
            paddingBottom: spacing.xxxLarge_64,
            backgroundSize: "500px auto",
            backgroundPosition: "50% 100%",
        },
    },
    title: {
        color: "black",
        fontFamily: "Source Serif Pro",
        fontWeight: 600,
        textAlign: "center",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        fontSize: 44,
        lineHeight: "48px",
        marginBottom: 42,
        [mediaQueries.smOrSmaller]: {
            fontSize: 30,
            lineHeight: "36px",
        },
    },
    bodyText: {
        color: color.offBlack,
        fontSize: 18,
        lineHeight: "30px",
        textAlign: "center",
        maxWidth: 450,
    },
    learnMore: {
        marginTop: spacing.xLarge_32,
    },
});
